'use client'
import {
  createLocalizedPathnamesNavigation,
  Pathnames
} from 'next-intl/navigation'
import { locales } from './i18n'

export const localePrefix = 'always'

export const pathnames: any = {
  '/': '/',
  '/about-us': '/about-us',
  '/favorites': '/favorites',
  '/services': '/services',
  '/contact': '/contact',
  '/apartments-for-sale': '/apartments-for-sale',
  '/apartments-for-rent': '/apartments-for-rent',
  '/houses-for-sale': '/houses-for-sale',
  '/houses-for-rent': '/houses-for-rent',
  '/commercial-properties-for-sale': '/commercial-properties-for-sale',
  '/commercial-properties-for-rent': '/commercial-properties-for-rent',
  '/land-for-sale': '/land-for-sale',
  '/land-for-rent': '/land-for-rent',
  '/real-estate-for-sale': '/real-estate-for-sale',
  '/add-estate-login': '/add-estate-login',
  '/add-estate-home': '/add-estate-home',
} satisfies Pathnames<typeof locales>

export const { Link, redirect, usePathname, useRouter, getPathname } =
  createLocalizedPathnamesNavigation({ locales, localePrefix, pathnames })
